import { useRef } from 'react';
import classnames from 'classnames/bind';
import { LazyVideo } from '@commonPackage/components';
import styles from './index.module.less';

const cx = classnames.bind(styles);

interface Props {
  videoPosition?: 'left' | 'right';
  src: string;
  title: string;
  text: React.ReactNode;
  bgUrl?: string;
  poster?: string;
}
const HorizontalVideo = ({ videoPosition, src, title, text, bgUrl, poster }: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  const components = new Map([
    [
      'video',
      <div key="video" className={cx('content-box')}>
        <div className={cx('video-box')}>
          <LazyVideo src={src} poster={poster} muted loop autoPlay />
        </div>
      </div>,
    ],
    [
      'text',
      <div key="text" className={cx('content-box', videoPosition === 'left' ? 'left' : 'right')}>
        <div className={cx('text-intro-container')}>
          <div className={cx('text-title')}>{title}</div>
          <div className={cx('text-content')}>{text}</div>
        </div>
      </div>,
    ],
  ]);
  const content = videoPosition === 'left' ? ['video', 'text'] : ['text', 'video'];

  return (
    <div className={cx('horizontal-video')} style={{ backgroundImage: `url(${bgUrl})` }} ref={ref}>
      {content.map(item => components.get(item))}
    </div>
  );
};

export default HorizontalVideo;
